module.exports = __webpack_public_path__ + "img/ELF-01.be0f3fd7.png";